/* global require, Toasts */
$(function () {
  'use strict'

  const followSelector = '[data-users-follow]'

  const follow = function (url, userId, textSubscribe) {
    const $objectSubscriptionElems = $(followSelector).filter('[data-user-id="' + userId + '"]')
    const $followElems = $objectSubscriptionElems.filter('[data-action="follow"]')
    const $unfollowElems = $objectSubscriptionElems.filter('[data-action="unfollow"]')

    $.post(url, {'user_id': userId})
      .done(function (response) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'
        if (response.success) {
          $followElems.addClass('layout__none')
          $unfollowElems.removeClass('layout__none')

          Toasts.pushToast(textSubscribe || 'Вы успешно подписались', 'success', undefined, 5000)
        }
        else {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          errorMessage = xhr.responseJSON.error
        }

        if (xhr.status === 409) {
          $followElems.addClass('layout__none')
          $unfollowElems.removeClass('layout__none')
        }

        if (typeof (xhr.responseJSON) === 'undefined' || typeof (xhr.responseJSON.id) === 'undefined') {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
  }

  const unfollow = function (url, userId, textUnsubscribe) {
    const $objectSubscriptionElems = $(followSelector).filter('[data-user-id="' + userId + '"]')
    const $followElems = $objectSubscriptionElems.filter('[data-action="follow"]')
    const $unfollowElems = $objectSubscriptionElems.filter('[data-action="unfollow"]')

    $.post(url, {'user_id': userId})
      .done(function (response) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'
        if (response.success) {
          $followElems.removeClass('layout__none')
          $unfollowElems.addClass('layout__none')

          Toasts.pushToast(textUnsubscribe || 'Вы успешно отписались', 'success', undefined, 5000)
        }
        else {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          errorMessage = xhr.responseJSON.error
        }

        if (xhr.responseJSON && xhr.responseJSON.unsubscribed) {
          $followElems.removeClass('layout__none')
          $unfollowElems.addClass('layout__none')
        }

        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
      })
  }

  $(document).on('click', followSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const action = $this.data('action')
    const url = $this.data('url')
    const userId = $this.data('userId')
    const errorMessage = 'Что-то пошло не так, попробуйте перезагузить страницу'
    const textSubscribe = $this.data('textSubscribe')
    const textUnsubscribe = $this.data('textUnsubscribe')

    if (!userId) {
      Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
      return
    }

    if (action === 'follow') {
      follow(url, userId, textSubscribe)
    }
    else if (action === 'unfollow') {
      unfollow(url, userId, textUnsubscribe)
    }
  })
})

